/** @packageDocumentation @publicapi @module resolve */
export * from './interface';
export * from './resolvable';
export * from './resolveContext';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/seanopa/PhpstormProjects/courtmenow-app/~/@uirouter/core/lib-esm/resolve/index.js
// module id = 69
// module chunks = 0